import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { RoutingService } from './core/services/routing.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnDestroy {

  closeResult: string;
  @ViewChild('mymodal', { static: true }) content: NgbModal;

  constructor(
    routingService: RoutingService,
    private modalService: NgbModal
  ) {
    routingService.loadRouting();
  }

  ngOnInit() {
    this.modalService.open(this.content, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  // This was requested by business. They want the first form field
  // focused after the user clicks "acknowledge."
  focusFirst = () => {
    var firstField = document.getElementById('employer');
    if (!firstField) {return;}
    firstField.focus();
  };

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  ngOnDestroy(): void { }

}